import axios from "axios";
import { store } from "../stores/store";
import { showNotification } from "../slices/AlertMessageSlice";
import { getToken } from "@/token/token";
import getHeaders from "@/domain/DomainHeader";
import Cookies from "js-cookie";

let APIFile = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
});

APIFile.interceptors.request.use(
  async (config) => {
    const token = getToken("token") || null;
    // const token =
    //   typeof window !== "undefined" ? localStorage.getItem("token") : null;
  // debugger;
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    
      
     
    }
    // debugger;
 const extra = await getHeaders(window.location.hostname);
         config.headers = {
       
        ...extra,
         "Content-Type": "multipart/form-data",
      };  
       debugger;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

APIFile.interceptors.response.use(
  (response) => {
    if (typeof window !== "undefined") {
      console.log("API response config", response);
      if (
        response.data.success &&
        (response.config.method === "post" ||
          response.config.method === "put" ||
          response.config.method === "delete")
      ) {
        // store.dispatch(
        //   showNotification({
        //     messageToaster: true,
        //     toasterType: "success",
        //     toasterMessage: response?.data?.message || "Success!",
        //   }),
        // );

        // if(response?.config?.url === "/auth/refresh-token") {
        //   store.dispatch(showNotification({ messageToaster: false, toasterType: "success", toasterMessage: response?.data?.message || "Success!"}));

        // }
        // else if(response?.config?.url === "/api/user-activity") {
        //   store.dispatch(showNotification({ messageToaster: false, toasterType: "success", toasterMessage: response?.data?.message || "Success!"}));

        // }
        // else if(response?.config?.url.includes("read")) {
        //   store.dispatch(showNotification({ messageToaster: false, toasterType: "success", toasterMessage: response?.data?.message || "Success!"}));

        // }
        // else {
        //   store.dispatch(showNotification({ messageToaster: true, toasterType: "success", toasterMessage: response?.data?.message || "Success!"}));

        // }
      }
    }

    return response;
  },

  function (error) {
    if (typeof window !== "undefined") {
      console.log("API error config", error);
      if (
        !error?.response?.data?.success &&
        // window.location.pathname.split("/").indexOf("auth") === -1 &&
        (error.config.method === "post" ||
          error.config.method === "put" ||
          error.config.method === "delete")
      ) {
        // store.dispatch(
        //   showNotification({
        //     messageToaster: true,
        //     toasterType: "error",
        //     toasterMessage:
        //       error?.response?.data?.message ||
        //       "Something went wrong! Please check your internet connecton.",
        //   }),
        // );
        // if(error?.config?.url === "/auth/refresh-token") {
        //   store.dispatch(showNotification({ messageToaster: false, toasterType: "error", toasterMessage: error?.response?.data?.message || "Something went wrong! Please check your internet connecton."}));

        // }
        // else if(error?.config?.url === "/api/user-activity") {
        //   store.dispatch(showNotification({ messageToaster: false, toasterType: "error", toasterMessage: error?.response?.data?.message || "Something went wrong! Please check your internet connecton."}));

        // }
        // else if(error?.config?.url.includes("read")) {
        //   store.dispatch(showNotification({ messageToaster: false, toasterType: "error", toasterMessage: error?.response?.data?.message || "Something went wrong! Please check your internet connecton."}));

        // }
        // else {
        //   store.dispatch(showNotification({ messageToaster: true, toasterType: "error", toasterMessage: error?.response?.data?.message || "Something went wrong! Please check your internet connecton."}));

        // }
      }
    }

    return Promise.reject(error);
  },
);

export default APIFile;
